import { ValueOf } from 'src/models/types/utility-types';

// src\app\services\occurrence\occurrence.service.ts
export const OccurrenceLoadingKeys = {
  Default: 'occurrence-page-list',
  Details: 'occurrence-page-details',
  /** Skeleton do modal Nova ocorrência (cartões / requisitos). */
  NovaOcorrenciaDialog: 'occurrence-nova-ocorrencia-dialog'
} as const;
export type OccurrenceLoadingKey = ValueOf<typeof OccurrenceLoadingKeys>;
